export class Name {
  idAccount: string;
  param: 'nombreCompleto';
  value: string;
}
export class Status {
  idAccount: string;
  param: 'estado';
  value: boolean;
}
